<template>
  <BaseFormV2
    :id="props.id"
    :model-class="Group"
    :before-save-hook="beforeSaveHook"
  />
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

import BaseFormV2 from '@/components/common/forms/BaseFormV2.vue'
import { Group } from '@/models/core/models'

type GroupFormProps = {
  id: string
}

const store = useStore()
const props = defineProps<GroupFormProps>()

function beforeSaveHook(group: Group) {
  // if new group
  if (props.id === '0') {
    group.organisation = store.getters['global/organisation'].id
  }
}
</script>
